import React from 'react'

const NearbySkeletonCard = ({ hideDescription = false }) => {
  return (
    <div
      className={`carousel-skeleton flex size-full max-w-[320px] animate-pulse flex-col  rounded-xl border border-gray-300 `}
    >
      <div className="aspect-golden h-[178px] w-full bg-gray-300 lg:h-[198px]"></div>
      <div className="flex h-[145px] w-full flex-col items-start bg-white p-4">
        <div className="mb-2 flex h-5 w-10/12 flex-col rounded-md bg-gray-300 pb-2"></div>
        <div className="mb-2 flex h-7 w-2/3 flex-col rounded-md bg-gray-300 pb-1"></div>
        <div className="mb-2 flex h-6 w-1/2 flex-col rounded-md bg-gray-300 pb-3"></div>
        <div className="flex w-full flex-row gap-2">
          <div className="flex h-4 w-1/2 flex-col rounded-md bg-gray-300"></div>
        </div>

        {!hideDescription && (
          <>
            <div className="mb-2 flex h-5 w-9/12 flex-col rounded-md bg-gray-300"></div>
            <div className="mb-2 flex h-5 w-2/3 flex-col rounded-md bg-gray-300"></div>
          </>
        )}
      </div>
    </div>
  )
}

export default NearbySkeletonCard
